import * as actions from "~features/seated-reservation/store/actions/index";
import { SeatSelectTypes, SortTypes } from "~components/reservation/constants";
import { SeatSelectionFilters } from "~graphql/sdk";

export const applySeatFilterDefaults = (
  defaultFilters: SeatSelectionFilters,
  converge: any
): void => {
  if (!defaultFilters.seatQuantity && !defaultFilters.selectType && !defaultFilters.sortType) {
    return;
  }

  actions.updateOptions({
    options: {
      amount: defaultFilters.seatQuantity,
      seatSelectType: defaultFilters.selectType as SeatSelectTypes,
      selectedSort: defaultFilters.sortType as SortTypes,
    }
  }, converge);
};